import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management_user" },
  { title: "menu_sidebar_management_user_team_management", link: "/management/user/user-list" }
];

const TakafulBazaarUserAdd = Loadable({
  loader: () => import("container/management/user/userList"),
  loading() {
    return <Loader />;
  }
});

const TakafulBazaarUserUserListListing = Loadable({
  loader: () => import("container/management/user/userList/listing"),
  loading() {
    return <Loader />;
  }
});

export const teamManagementRoutes: IRoute[] = [
  {
    path: "/management/user/user-list",
    element: <TakafulBazaarUserUserListListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/management/user/user-list/details/:id?",
    element: <TakafulBazaarUserAdd />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
